import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  allChats: [],
  chatMessages: [],
  socket: {},
  isConnected: false,
};
const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setAllChat(state, action) {
      state.allChats = action.payload;
    },
    createNewChat(state: any, action) {
      if (state.allChats) state.allChats.data.unshift(action.payload);
    },
    setNewMessage(state: any, action: any) {
      state.chatMessages.unshift(action.payload);
    },
    setChatMessages(state, action) {
      state.chatMessages = action.payload;
    },
    setSocketConnection(state, action) {
      state.socket = action.payload.socket;
      state.isConnected = action.payload.isConnected;
    },
  },
});
export const { setAllChat, createNewChat, setNewMessage, setChatMessages, setSocketConnection } =
  chatSlice.actions;
export default chatSlice;
